export default __webpack_public_path__ + "static/google-play_download_us-c2795fabe093192d23d6f9383f30040d.png";